/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'log-bar-chart';
const prefix = `${moduleName}.${componentName}`;

export const eventsPluralLabel = `${prefix}.eventsPluralLabel`;

export const ENGLISH = {
    [eventsPluralLabel]: '{0, plural, one{# <span class="units"> event</span>} other{# <span class="units"> events</span>}}',
};
